import { RichContent } from '@corratech/pylot-rich-content'
import React, { useEffect } from 'react'
import { useCmsBlocks } from '@pylot-data/hooks/cms/use-cms-blocks'
import { Layout } from '@components/common'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import { getCMSBlock } from '@components/common/CMSBlockConst/cms-block-util'
import { GetStaticProps, GetStaticPropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'
import s from '@pagestyles/Cms.module.scss'
import { Referrals as ReferralsSEO } from '@components/seo/src/Referrals'

const REFERRAL_PAGE_BLOCK = 'referrals_page_block'

declare global {
    interface Window {
        yotpoWidgetsContainer: {
            initWidgets: () => void
        }
    }
}

export const getStaticProps: GetStaticProps = async ({
    locale
}: GetStaticPropsContext) => {
    return {
        props: {
            ...(await serverSideTranslations(locale!, ['common', 'account']))
        },
        revalidate: 14400
    }
    return {
        notFound: true,
        revalidate: 1
    }
}

export default function Rewards(): JSX.Element {
    const config = useStoreConfig()
    const { toggleYotpoReviewPageWidget } = useAlfakherContext()

    const { items: CmsBlocks } = useCmsBlocks([REFERRAL_PAGE_BLOCK], {
        revalidateOnMount: true,
        revalidateOnFocus: false
    })

    const findWidget = () => {
        return document.querySelector('.yotpo-widget-loyalty-page')
    }

    const reInitializeWidget = () => {
        const yotpoWidget = findWidget()

        if (yotpoWidget) {
            window.yotpoWidgetsContainer?.initWidgets()
            yotpoWidget.remove()
        } else if (
            typeof window &&
            window.yotpoWidgetsContainer &&
            typeof window.yotpoWidgetsContainer?.initWidgets === 'function'
        ) {
            window.yotpoWidgetsContainer?.initWidgets()
        }
    }

    useEffect(() => {
        reInitializeWidget()
    }, [toggleYotpoReviewPageWidget])

    return (
        <div className={s['cms-page']}>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <ReferralsSEO pathname="referrals" />
            <div
                className="yotpo-widget-instance"
                data-yotpo-instance-id={
                    config.base.yotpoLoyalty.widget_ids?.referralsPage
                }
            />
            <RichContent html={getCMSBlock(REFERRAL_PAGE_BLOCK, CmsBlocks)} />
        </div>
    )
}

Rewards.Layout = Layout
